import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';

import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: true,
    imports: [
    ProgressSpinnerModule
],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpinnerComponent implements OnInit {

  isLoading = input<boolean>(false);

  constructor() { }

  ngOnInit(): void {
  }

}
